// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PickUpInstruction: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 120" x="0px" y="0px" fill="CurrentColor">
        <g>
            <circle cx="63" cy="28.0034" r="2"/>
            <path d="M63,50a1.9988,1.9988,0,0,0,2-2V36a2,2,0,0,0-4,0V48A1.9988,1.9988,0,0,0,63,50Z"/>
            <path d="M24,28H38a2,2,0,0,0,0-4H24a2,2,0,0,0,0,4Z"/>
            <path d="M24,36H38a2,2,0,0,0,0-4H24a2,2,0,0,0,0,4Z"/>
            <path d="M24,44H38a2,2,0,0,0,0-4H24a2,2,0,0,0,0,4Z"/>
            <path d="M24,52H38a2,2,0,0,0,0-4H24a2,2,0,0,0,0,4Z"/>
            <path d="M90,20H84V14a1.9988,1.9988,0,0,0-2-2H56a9.9619,9.9619,0,0,0-8,4.0618A9.9619,9.9619,0,0,0,40,12H14a1.9988,1.9988,0,0,0-2,2v6H6a1.9988,1.9988,0,0,0-2,2V70a1.9988,1.9988,0,0,0,2,2H26c10.9141,0,14.4316,3.2422,20.4,11.1992a1.998,1.998,0,0,0,3.1992,0C55.7988,74.9336,59.209,72,66,72H90a1.9988,1.9988,0,0,0,2-2V22A1.9988,1.9988,0,0,0,90,20ZM56,16H80V60H58a11.4329,11.4329,0,0,0-8,3.7188V22A6.0066,6.0066,0,0,1,56,16ZM16,16H40a6.0066,6.0066,0,0,1,6,6V63.8418C43.7441,61.6,40.9551,60,38,60H16ZM88,68H66c-8.4336,0-12.918,4.166-18.0039,10.7051C42.7246,71.9961,37.8691,68,26,68H8V24h4V62a1.9988,1.9988,0,0,0,2,2H38c3.0938,0,6.541,3.5527,8.2109,6.8945A1.9993,1.9993,0,0,0,48,72a2.0476,2.0476,0,0,0,.459-.0527,1.9812,1.9812,0,0,0,1.3186-1.085l.0115.0322C51.4551,67.5605,54.4883,64,58,64H82a1.9988,1.9988,0,0,0,2-2V24h4Z"/>
            </g>
            </svg>;
};

export default React.memo(PickUpInstruction);
